export const WebSocketSubscribe = {
    EventSnapshot: 'eventSnapshot',
    EventLiveTelemetry: 'eventLiveTelemetry',
    EventConnectionAssigned: 'eventConnectionAssigned',
    Speech: 'speech',
    AudioChunk: 'audioChunk',
    PresenterConfig: 'presenterConfig',
};
/** Query flags for /ws (must match backend WebSocketConnectionQuery). */
export const WebSocketConnectionQuery = {
    Module: 'module',
    Admin: 'admin',
    PreferredAudioSourceDeviceId: 'preferredAudioSourceDeviceId',
};
export const AdminClientMessageTypes = {
    AudioSourcesSync: 'audioSourcesSync',
    AudioUpload: 'audioUpload',
    LiveInputAudioMonitor: 'liveInputAudioMonitor',
};
